export enum LocaleEnum {
	GB = 'gb',
	RS = 'rs',
  BA = 'ba',
  MK = 'mk',
  AL = 'al',
  ME = 'me',
  HR = 'hr',
}
